import React from "react";
import CashMgmt from "./assets/cashMgmt.svg";
import CoOpMem from "./assets/co-op-membership.svg";
import Inventory from "./assets/inventory.svg";
import MicroLoan from "./assets/microloan.svg";
import OnBoard from "./assets/onboard.svg";
import Payments from "./assets/payments.svg";
import Payout from "./assets/payout.svg";
import Security from "./assets/security.svg";
import SideCircle from "./assets/sidecircle.svg";
import TextLine from "./assets/textline.svg";
import CurrencyXchange from "./assets/currency-exchange.svg";
import Zigzag from "./assets/zig-zag.svg";
import styles from "./HomeFeatures.module.scss";
import {motion} from 'framer-motion'
const { features, content, header, block } = styles;
const HomeFeatures = () => {
  return (
    <section className={`${features} `}>
      <div className={header}>
        <motion.h1 
        initial={{
          y : '4rem', 
          opacity: 0 
        }}
        whileInView={{
          y : 0  , 
          opacity : 1 ,
          transition : { 
            duration : 1,
            type : 'tween', 
            delay :.2 
          }
        }}>
          Features
          <img src={TextLine} alt="nice lines" />
        </motion.h1>
        <img src={SideCircle} alt="nice circules" />
        <img src={Zigzag} alt="nice zig-zag lines" />
      </div>
      <div className={`${content} global-lr-pad`}>
    <motion.div 
     initial={{
          x : '-14rem', 
          opacity: 0 
        }}
        whileInView={{
          x : 0  , 
          opacity : 1 ,
          transition : { 
            duration : .7,
            type : 'tween' 
          }
        }}
    >


        <Feature>
          <div>
            <img src={Payout} alt="Payouts" />
          </div>
          <div>
            <h3>Payouts</h3>
            <p>You can cash out your funds.</p>
          </div>
        </Feature>
        <Feature>
          <div>
            <img src={CashMgmt} alt="Cash Management" />
          </div>
          <div>
            <h3>Cash Management</h3>
            <p>
              ou have a savings option where you can save funds and contribute
              to financial goals.
            </p>
          </div>
        </Feature>
        <Feature>
          <div>
            <img src={Inventory} alt="Inventory" />
          </div>
          <div>
            <h3>Inventory Management </h3>
            <p>
              Generate receipts for customers and guarantees to help users save
              money, Vendor will benefit from boosting productivity, by tracking
              inventory levels, orders, sales and deliveries.
            </p>
          </div>
        </Feature>
    </motion.div>
    <motion.div 
    
    initial={{
          y : '4rem', 
          opacity: 0 
        }}
        whileInView={{
          y : 0  , 
          opacity : 1 ,
          transition : { 
            duration : .7,
            type : 'tween' , 
            delay : .5
          }
        }}>

        <Feature>
          <div>
            <img src={Payments} alt="Payments" />
          </div>
          <div>
            <h3>Payments</h3>
            <p>
              Support an array of payment methods: There's a variety of payment
              options you can choose from. If you prefer to use cards, or make
              direct debits from other banks, our platform supports different
              payment methods.
            </p>
            <p>
              optimized for scalability, efficiency, and security.User can
              transfer and accept funds.
            </p>
          </div>
        </Feature>
        <Feature>
          <div>
            <img src={OnBoard} alt="On-boarding" />
          </div>
          <div>
            <h3>Instant On-boarding</h3>
            <p>
              Merchants can begin accepting payments instantly. Now you can send
              and receive money at once over long distances.
            </p>
          </div>
        </Feature>

        <Feature>
          <div>
            <img src={CoOpMem} alt="Co-op membership" />
          </div>
          <div>
            <h3>Co-op Membership </h3>
            <span>Coming Soon</span>
          </div>
        </Feature>
    </motion.div>
    <motion.div 
    initial={{
          x : '14rem', 
          opacity: 0 
        }}
        whileInView={{
          x : 0  , 
          opacity : 1 ,
          transition : { 
            duration : .7,
            type : 'tween'  , 
            delay : .7
          }
        }}>

        <Feature>
          <div>
            <img src={Security} alt="Security" />
          </div>
          <div>
            <h3> Security </h3>
            <p>Fraud protection with AI and rule-based risk ecosystem.</p>
          </div>
        </Feature>
        <Feature>
          <div>
            <img src={MicroLoan} alt="Mico-loans" />
          </div>
          <div>
            <h3> Micro-Loans </h3>
            <span>Coming soon</span>
          </div>
        </Feature>
        <Feature>
          <div>
            <img src={CurrencyXchange} alt="Currency Exchange" />
          </div>
          <div>
            <h3> Currency Exchange </h3>
            <span>Coming soon</span>
          </div>
        </Feature>
    </motion.div>
  
      </div>
    </section>
  );
};

const Feature = ({ children }) => <div className={block}>{children}</div>;
export default HomeFeatures;
